import { ReceiverEmailViewModel } from './receiver-email.model';
import { SenderEmailViewModel } from './sender-email.model';

export class EmailViewModel {
  constructor(
    public senderEmail: SenderEmailViewModel,
    public receiverEmail: ReceiverEmailViewModel
  ) {}
}
